// extracted by mini-css-extract-plugin
module.exports = {"container":"download_container__1c_42","container__icon":"download_container__icon__3HBXb","container__link":"download_container__link__2QinZ"};